import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterById',
    standalone: false
})
export class FilterByIdPipe implements PipeTransform {
  transform(items:Array<any>, id?) {
    if(items){
      return items.filter(item => item.id == id)[0];
    }
  }
}
